// Holds a static, admin-only shared secret (not a per-user session token) forwarded from
// Main_Web2's admin-only build via postMessage. Used to prove this specific call is coming
// from the trusted admin embed, since the regular MindMeKey is shipped in every visitor's
// bundle and proves nothing about admin privilege.
//
// The admin grid route can mount (from the iframe's initial URL) before the postMessage
// carrying the key arrives, so callers that need to wait for it should use subscribe()
// rather than reading adminApiKey once at mount time.
class AdminAuthStore {
  public adminApiKey: string = "";
  private listeners = new Set<(key: string) => void>();

  setAdminApiKey(key: string) {
    this.adminApiKey = key || "";
    this.listeners.forEach((listener) => listener(this.adminApiKey));
  }

  subscribe(listener: (key: string) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export default new AdminAuthStore();
